/* eslint-disable react/prop-types */
import { cssVars } from '@/app/styles';
import { DATA_STATUS, INIT_NOTE_ADD_STATUS } from '@/constants';
import * as dataActions from '@/data/data-actions';
import {
  noteAddStatus as noteAddStatusSelector,
  propertyData as propertyDataSelector,
} from '@/data/data-selectors';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'rsuite';
import styled from 'styled-components';
import { ViolationDetailsReport } from '../details-info-modules/issue-report-panes/violation-report-pane';

const NOTE_MAX_LENGTH = '2000';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 360px;
  min-width: 360px;
  padding: 30px;
  border: solid 1px #e8e8e8;
  border-radius: 8px;
  background-color: #fafafa;
`;

const NotesInput = styled.textarea`
  width: 300px;
  height: 200px;
  margin: 10px 0 0 0;
  padding: 11px 12px 167px;
  border-radius: 4px;
  border: solid 1px #8c8c8c;
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.85);
  resize: none;
`;

const AddNoteTitle = styled.div`
  width: 62px;
  height: 14px;
  margin: 20px 38px 0px 0px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
`;

const AddButton = styled(Button)`
  margin: 8px 0px;
  width: 120px;
  height: 36px;
  border-radius: 6px;
  background-color: ${cssVars.color.rentalscapeBlue};
  text-align: center;
`;

const NoteAddSuccessAnimatedMessage = styled.div`
  color: #389e0d;
  animation: add-note-fadeout 0.5s 1;
  animation-fill-mode: forwards;
  animation-delay: 3s;
  display: ${(props) => (props.hide ? 'none' : 'inherit')};

  @keyframes add-note-fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

/**
 * This component renders the box we use for viewing violations and adding notes in the
 * license management tabs
 *
 * @param {*} props
 */
export function ViolationSummaryNotes(props) {
  const { listings, licenseTabParam } = props;
  const dispatch = useDispatch();
  const propertyData = useSelector(propertyDataSelector);
  const { inFlight: noteAddInflight, addedNoteId } = useSelector(
    noteAddStatusSelector
  );
  const [message, setMessage] = useState('');

  useEffect(
    () => () => {
      // this is here so that the success message does not appear w/o a note being added on tab change
      dispatch(dataActions.setNoteAddStatus(INIT_NOTE_ADD_STATUS));
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleInputChange = useCallback(
    (evt) => {
      setMessage(evt.target.value);
    },
    [setMessage]
  );

  const addNoteCB = useCallback(() => {
    dispatch(
      dataActions.userAddedNote({
        message,
        propertyDeckardID: propertyData.deckardid,
        licenseTabParam,
      })
    );
    setMessage('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, propertyData.deckardid, licenseTabParam]);

  if (propertyData === DATA_STATUS.inProgress) {
    return (
      <div>
        <Wrapper>Loading violations data...</Wrapper>
      </div>
    );
  }

  return (
    <div>
      <Wrapper>
        <ViolationDetailsReport listings={listings} bordered />
        <AddNoteTitle>Add Note</AddNoteTitle>
        <NotesInput
          type="text"
          placeholder="Notes"
          value={message}
          onChange={handleInputChange}
          maxLength={NOTE_MAX_LENGTH}
        />
        <div css="display: flex; justify-content: space-between; align-items: baseline">
          <AddButton
            loading={noteAddInflight}
            disabled={!message}
            appearance="primary"
            onClick={addNoteCB} // eslint-disable-line no-console
          >
            Add
          </AddButton>
          <NoteAddSuccessAnimatedMessage
            hide={!addedNoteId || noteAddInflight === true}
            key={addedNoteId}
          >
            Note added successfully!
          </NoteAddSuccessAnimatedMessage>
        </div>
      </Wrapper>
    </div>
  );
}
